// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maintenance[data-v-f2a0138c]{padding:40px 0;max-width:480px}@media(min-width:992px){.maintenance[data-v-f2a0138c]{padding:80px 0;margin-left:120px}}.maintenance img[data-v-f2a0138c]{margin-bottom:30px}@media(min-width:992px){.maintenance img[data-v-f2a0138c]{margin-bottom:40px}}.maintenance .main-text[data-v-f2a0138c],.maintenance h2[data-v-f2a0138c]{margin-bottom:30px}.maintenance h2[data-v-f2a0138c]{color:var(--color-text)}", ""]);
// Exports
module.exports = exports;
